var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.624 0 24 5.376 24 12C24 18.624 18.624 24 12 24C5.376 24 0 18.624 0 12C0 5.376 5.376 0 12 0ZM12 6C8.688 6 6 8.688 6 12C6 15.312 8.688 18 12 18C14.184 18 16.0956 16.8324 17.1456 15.0864L15.0876 13.8528C14.7637 14.3923 14.3041 14.8376 13.7545 15.1441C13.2049 15.4506 12.5845 15.6077 11.9553 15.5997C11.326 15.5917 10.7099 15.4189 10.1683 15.0986C9.62662 14.7782 9.17842 14.3214 8.86834 13.7738C8.55827 13.2262 8.39716 12.6069 8.40106 11.9776C8.40497 11.3484 8.57377 10.7311 8.89062 10.1874C9.20747 9.64369 9.6613 9.19254 10.2069 8.87892C10.7525 8.5653 11.3707 8.40017 12 8.4C13.3116 8.4 14.46 9.1008 15.0888 10.1484L17.1456 8.9124C16.6125 8.02388 15.8583 7.28861 14.9565 6.77821C14.0548 6.26782 13.0362 5.99971 12 6Z",
    fill: "#0057FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.17be6168acced74f7043d91bb56d7f3c.svg";
export { ForwardRef as ReactComponent };